
































import { DistanceApi } from "../api/DistanceApi";
import DistanceLine from "./FraisDetailsModalPartials/DistanceLine.vue";
import { Trajet } from "../models/Trajet";
import Distance = Trajet.Distance;

export default {
    name: "DistancesList",
    components: {
        DistanceLine: DistanceLine,
    },
    data() {
        return {
            computedDistances: [],
            validatedDistances: [],
            modifiedDistances: [],
            DistanceApi: new DistanceApi(),
        };
    },
    created() {
        // Listes complètes attendues : limite explicite (le serveur tronquait
        // silencieusement à 100 par défaut).
        const all = 100000;
        this.DistanceApi.getAll({
            status: Distance.EStatus.Computed,
            limit: all,
        }).then((distances) => {
            this.computedDistances = distances;
        });
        this.DistanceApi.getAll({
            status: Distance.EStatus.Validated,
            limit: all,
        }).then((distances) => {
            this.validatedDistances = distances;
        });
        this.DistanceApi.getAll({
            status: Distance.EStatus.Manual,
            limit: all,
        }).then((distances) => {
            this.modifiedDistances = distances;
        });
    },
};
